<template>
  <div class="login-wrap">
    <div class="container">
      <h5 class="h5">登录</h5>
      <van-tabs v-model="active" class="tab-box">
        <van-tab title="密码登录">
          <van-form @submit="onSubmit">
            <van-field v-model="tel" type="tel" name="tel" placeholder="请输入手机号码" />
            <van-field v-model="password" type="password" name="pwd" placeholder="请输入密码" />
            <div class="forgetPassword" @click="goToBind">忘记密码？</div>
            <van-button
              class="login-btn"
              native-type="submit"
              :class="{ active: tel != '' && password != '' }"
              >登录</van-button
            >
          </van-form>
        </van-tab>
        <van-tab title="验证码登录">
          <div class="code-title">未注册的手机号验证通过后将自动注册</div>
          <van-form @submit="onSubmit2">
            <van-field
              v-model="tel2"
              type="tel"
              name="tel2"
              placeholder="请输入手机号码"
              ref="tel2"
            />
            <div class="code-box">
              <van-field
                v-model="codeNumber"
                class="code-input"
                type="number"
                name="codeNumber"
                placeholder="请输入验证码"
              />
              <button class="click-btn" :disabled="disabled" @click="validateBtn">
                {{ btnTitle }}
              </button>
            </div>
            <van-button
              class="login-btn"
              native-type="submit"
              :class="{ active: tel2 != '' && codeNumber != '' }"
              >登录
            </van-button>
          </van-form>
        </van-tab>
      </van-tabs>
      <div class="p1" v-show="isShowFlag">
        注册/登录代表您已阅读并同意<span @click="goToDeal">呼呼打药用户协议</span>
      </div>
      <div class="foot" v-show="isShowFlag">
        <DownApp></DownApp>
      </div>
    </div>
  </div>
</template>
<script>
import DownApp from '../../components/downApp/downApp';
import axios from '../../http';
import md from '../../common/js/md5';
import { mapMutations } from 'vuex';
export default {
  name: 'login',
  components: {
    DownApp,
  },
  props: {},
  data() {
    return {
      active: 0, //默认显示手机验证码登录
      tel: '',
      password: '',
      tel2: '', //验证码登录的手机号码
      codeNumber: '', //验证码登录的验证码
      disabled: false, //禁用获取获取验证码按钮
      btnTitle: '获取验证码', //获取验证码按钮文案
      isShowFlag: true,
      documentHeight: document.documentElement.clientHeight,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    window.onresize = () => {
      return (() => {
        if (this.documentHeight > document.documentElement.clientHeight) {
          this.isShowFlag = false;
        } else {
          this.isShowFlag = true;
        }
      })();
    };
  },
  destroyed() {},
  methods: {
    ...mapMutations(['getUserAvatar', 'getUserName', 'getUserPhone', 'getToken', 'setUserType']),
    onSubmit(values) {
      //密码登录提交按钮
      let tel = values.tel;
      let pwd = values.pwd;

      if (tel == '') {
        this.$toast('手机号不能为空');
        return;
      }
      if (tel.length < 11) {
        this.$toast('请输入正确的手机号码');
        return;
      }
      if (pwd == '') {
        this.$toast('密码不能为空');
        return;
      }
      let that = this;
      axios
        .fetchPost('/member/login/check_login_pass', {
          mobile: that.tel,
          password: md(that.password),
          business_type: 'h5',
        })
        .then((res) => {
          let data = res.data;
          this.$toast(data.msg);
          if (data.code == 200) {
            that.getUserAvatar(res.data.data.avatar);
            that.getUserName(res.data.data.nickname);
            that.getUserPhone(res.data.data.mobile);
            that.getToken(res.data.data.token);
            that.setUserType(res.data.data.user_type);
            if (res.data.data.user_type == 1) {
              setTimeout(() => {
                this.$router.push({
                  path: '/secondBar/medication',
                });
              }, 500);
            } else if (res.data.data.user_type == 0) {
              setTimeout(() => {
                that.$router.push({
                  path: '/identity',
                  query: { token: res.data.data.token },
                });
              }, 500);
            } else {
              this.$router.replace({
                path: '/notFarmer',
              });
            }
          } else if (res.data.code == 211) {
            that.$router.push({
              path: '/identity',
              query: { token: res.data.data.token },
            });
          }
        })
        .catch((error) => {
          console.log('error :', error);
        });
    },
    onSubmit2(values) {
      //手机号登录提交按钮
      let tel = values.tel2;
      let code = values.codeNumber;

      if (tel == '') {
        this.$toast('请输入手机号码');
        return;
      } else if (tel.length < 11) {
        this.$toast('请输入正确的号码');
        return;
      }
      if (code == '') {
        this.$toast('请输入验证码');
        return;
      }
      let that = this;

      axios
        .fetchPost('/member/login/check_quick_login', {
          mobile: this.tel2,
          code: this.codeNumber,
          business_type: 'h5',
        })
        .then((res) => {
          // console.log(res);
          this.$toast(res.data.msg);
          that.getToken(res.data.data.token);
          that.getUserAvatar(res.data.data.avatar);
          that.getUserName(res.data.data.nickname);
          that.getUserPhone(res.data.data.mobile);
          that.setUserType(res.data.data.user_type);
          if (res.data.code == 200) {
            if (res.data.data.user_type == 1) {
              setTimeout(() => {
                this.$router.push({
                  path: '/secondBar/medication',
                });
              }, 500);
            } else if (res.data.data.user_type == 0) {
              setTimeout(() => {
                that.$router.push({
                  path: '/identity',
                  query: { token: res.data.data.token },
                });
              }, 500);
            } else {
              this.$router.replace({
                path: '/notFarmer',
              });
            }
          } else if (res.data.code == 211) {
            that.$router.push({
              path: '/identity',
              query: { token: res.data.data.token },
            });
          }
        })
        .catch((error) => {
          that.$toast(error);
        });
    },

    gotoIdentity() {
      // this.$router.push({
      //   path: "/identity"
      // });
    },
    goToDeal() {
      this.$router.push({
        path: '/deal',
      });
    },
    goToBind() {
      this.$router.push({
        path: '/lookforPwd',
      });
    },
    validateBtn() {
      //如果没有手机号码 验证
      if (this.tel2.length < 11) {
        this.$refs.tel2.focus();
        return;
      }
      let that = this;
      //发送验证码
      axios
        .fetchPost('/member/login/sendsms', { mobile: this.tel2 })
        .then(function(res) {
          // console.log(res);
          that.$toast(res.data.msg);
        })
        .catch(function(error) {
          that.$toast(error);
        });
      //倒计时按钮
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.disabled = false;
          this.btnTitle = '获取验证码';
        } else {
          time--;
          this.disabled = true;
          this.btnTitle = `${time}s后重试`;
        }
      }, 1000);
    },
  },
};
</script>
<style lang="stylus" scoped>
.login-wrap
  height 100%
  background linear-gradient(-30deg, rgba(79, 194, 101, 1), rgba(0, 164, 103, 1), rgba(18, 154, 140, 1))
  .container
    padding-top 75px
    .h5
      font-size 25px
      color #fff
    .tab-box
      width 70%
      margin 0 auto
      /deep/.van-tabs__nav
        background none
        .van-tab
          color rgba(255, 255, 255, 0.5)
        .van-tab--active
          color #fff
        .van-tabs__line
          background #fff
      .van-tab__pane
        padding-top 40px
        position relative
        .van-cell
          background none
          border-radius 40px
          margin-bottom 10px
          border 1px solid rgba(255, 255, 255, 0.5)
          &::after
            display none
          /deep/.van-field__control
            color #fff
        .forgetPassword
          line-height 1.1
          text-align right
          color #fff
          font-size 12px
          margin-bottom 32px
        .login-btn
          width 100%
          background rgba(255, 255, 255, 0.7)
          border-radius 40px
          height 40px
          line-height 40px
          font-family Microsoft YaHei
          font-weight 400
          color rgba(40, 40, 40, 1)
          outline none
          border none
          &.active
            background #FF9922
            color #fff
    .p1
      position absolute
      bottom 80px
      left 0
      right 0
      color rgba(255, 255, 255, 0.5)
      font-size 12px
      line-height 24px
      & > span
        color #ffffff
        margin-left 5px
    .code-title
      position absolute
      top 10px
      font-size 12px
      font-family Microsoft YaHei
      font-weight 400
      color rgba(255, 255, 255, 0.5)
      left 0
      right 0px
    .van-tab__pane
      .code-box
        display flex
        margin-bottom 45px
        .code-input
          width 65%
          display inline-block
          border 1px solid rgba(255, 255, 255, 0.5)
          border-right 0
          border-radius 40px
          border-top-right-radius 0px
          border-bottom-right-radius 0px
        .click-btn
          width 35%
          display inline-block
          color #fff
          font-size 13px
          font-family Microsoft YaHei
          line-height 46px
          border 1px solid rgba(255, 255, 255, 0.5)
          border-radius 40px
          height 46px
          border-top-left-radius 0px
          border-bottom-left-radius 0px
          background none
</style>
